import React, { useMemo, useState } from 'react';
import { marked } from 'marked';
import { Copy, Check } from 'lucide-react';
import './AiReportView.css';

// Configure marked for clean GFM parsing with breaks
marked.setOptions({
    gfm: true,
    breaks: true
});

const AiReportView = ({ content }) => {
    const [copied, setCopied] = useState(false);

    const formattedHtml = useMemo(() => {
        if (!content || typeof content !== 'string') return '';

        // Normalize non-breaking / narrow spaces
        let cleaned = content
            .replace(/[\u202F\u00A0]/g, ' ')
            .replace(/\r\n/g, '\n');

        // Convert standalone bold lines like "**📊 Загальна картина**" or "**🎯 Дії...**" into markdown headings
        cleaned = cleaned.replace(/^\s*\*\*([^\n*]+)\*\*\s*$/gm, '### $1');

        try {
            return marked.parse(cleaned);
        } catch (e) {
            console.error('Failed to parse markdown in AiReportView:', e);
            return `<pre style="white-space: pre-wrap;">${content}</pre>`;
        }
    }, [content]);

    const handleCopy = () => {
        if (!content) return;
        navigator.clipboard.writeText(content).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch(err => {
            console.error('Failed to copy text:', err);
        });
    };

    if (!content) return null;

    return (
        <div className="ai-report-container">
            <div className="ai-report-toolbar">
                <span className="ai-report-badge">AI Intelligence Report</span>
                <button
                    type="button"
                    className={`ai-copy-btn ${copied ? 'copied' : ''}`}
                    onClick={handleCopy}
                    title="Скопіювати звіт"
                >
                    {copied ? <Check size={14} /> : <Copy size={14} />}
                    <span>{copied ? 'Скопійовано!' : 'Скопіювати'}</span>
                </button>
            </div>
            <div
                className="ai-report-content"
                dangerouslySetInnerHTML={{ __html: formattedHtml }}
            />
        </div>
    );
};

export default AiReportView;
